export default {
	name : "header",
    _id: "header",
    _selector: "header",
	_disable: true,
    init() {
        const header  = document.querySelector(this._selector);

		if (!header || this._disable) return;

		let lastScrollTop = 0;

		window.addEventListener("scroll", function(){
		   const st = window.pageYOffset || document.documentElement.scrollTop; 
		   if (st > lastScrollTop){
				header.classList.add("header--slide-up")
		   } else {
				header.classList.remove("header--slide-up")
		   }
		   lastScrollTop = st <= 0 ? 0 : st;
		}, false);
    },
};
